var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 41"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 5,
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5h35",
    "data-name": "Line 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 38.5h35",
    "data-name": "Line 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 20.5h35",
    "data-name": "Line 4"
  }))));
};
export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MSI+CiAgPGcgZGF0YS1uYW1lPSJHcm91cCAyIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjUiPgogICAgPHBhdGggZGF0YS1uYW1lPSJMaW5lIDIiIGQ9Ik0yLjUgMi41aDM1Ii8+CiAgICA8cGF0aCBkYXRhLW5hbWU9IkxpbmUgMyIgZD0iTTIuNSAzOC41aDM1Ii8+CiAgICA8cGF0aCBkYXRhLW5hbWU9IkxpbmUgNCIgZD0iTTIuNSAyMC41aDM1Ii8+CiAgPC9nPgo8L3N2Zz4=";